const index = () => import('./pages/index')

export default[
  {
    path: '/payer_contacts',
    name: 'payer.contacts',
    component: index,
    meta: { requiresAuth: true }
  }
]



// WEBPACK FOOTER //
// ./src/features/payer_contacts/routes.js